<template src="./html/Index.html"></template>

<script>
	import swal from 'sweetalert2'
	import Datatable from './Datatable.vue'
	import Fav from './Fab'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'datatable': Datatable,
			'fab': Fav,
		},
		data () {
			return {
			}
		},
		methods: {
			reload() {
				this.$nextTick( () => this.$refs.datatable.reload())
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/management/orders/views/Index.vue